var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wish-list",attrs:{"id":"wish-list","dir":_vm.dir}},[_vm._l((_vm.currentPosts),function(post,index){return _c('surface-post',{key:post.cid,attrs:{"index":index,"post":post,"edit":_vm.inlinePostEdit}})}),_vm._v(" "),_c('div',{staticClass:"wish-sizer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }